module.exports = __webpack_public_path__ + "static/media/PAL_Image_2158x477-600dpi.3f9d2040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PAL_Image_2158x477-600dpi.png
// module id = 1375
// module chunks = 0